import type { CostCenterSeatChangeSeatTypeEnum } from '@/api/generated/api'
import { Dropdown, DropdownItem } from '@/components/Dropdown'
import { ProductSeatType } from '@/types'
import { seatTypeLabel, seatTypeTitle } from '@/utils/seatType'

export type SelectableSeatType = CostCenterSeatChangeSeatTypeEnum

const OPTIONS: { id: SelectableSeatType; helperText: string }[] = [
  {
    id: ProductSeatType.Dictation,
    helperText: 'Unlimited dictation, but Notetaker is unavailable for this member.',
  },
  {
    id: ProductSeatType.Bundle,
    helperText: 'Unlimited dictation plus access to Notetaker.',
  },
]

interface SeatTypeDropdownProps {
  role: string | null | undefined
  seatType: string | null | undefined
  ariaLabel: string
  disabled: boolean
  onSelect?: (seatType: SelectableSeatType) => void
  placeholder?: string
}

export const SeatTypeDropdown = ({
  role,
  seatType,
  ariaLabel,
  disabled,
  onSelect,
  placeholder = 'No seat recorded',
}: SeatTypeDropdownProps) => {
  const items: DropdownItem[] = OPTIONS.map((option) => ({
    ...option,
    title: seatTypeLabel[option.id],
    selected: option.id === seatType,
  }))

  // "No access" isn't something an admin picks here, so it shows as a summary rather than a selected option.
  const title = seatTypeTitle(role, seatType)
  const summary = title === seatTypeLabel[ProductSeatType.NoAccess] ? title : undefined

  const handleSelect = (selectedItems: DropdownItem[]) => {
    if (selectedItems.length === 0) return

    onSelect?.(selectedItems[0].id as SelectableSeatType)
  }

  return (
    <Dropdown
      items={items}
      searchable={false}
      onSelect={handleSelect}
      placeholder={placeholder}
      summary={summary}
      disabled={disabled}
      ariaLabel={ariaLabel}
      width="100%"
    />
  )
}
